import { AssetsConfigModalWithWrappers } from './AssetsConfigModalWithWrappers';

export const ASSETS_LIST_OF_LINKS_DATASOURCE_ID = '361d618a-3c04-40ad-9b27-3c8ea6927020';

export default AssetsConfigModalWithWrappers;
